import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 117.84 81.89"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M73.34 0 39.16 39.16H0L34.18 0h39.16Zm0 81.89L39.16 42.9H0l34.18 38.99h39.16Zm44.5-40.41L80.28 19.76 42.72 41.12l37.2 21.54 37.92-21.18Z",
      style: {"fill":"#008e8f","fill-rule":"evenodd"}
    }, null, -1)
  ]))]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "EN-logo"}) } }